/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Servicios from "./Componentes/Home_Servicios";
import Home_Experiencias from "./Componentes/Home_Experiencias";
import Home_Tradicion from "./Componentes/Home_Tradicion";
import Home_Contactos from "./Componentes/Home_Contactos";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Home = () => {
    const {sCell, masSM} = useResponsive()

    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Home_Servicios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Experiencias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 12 : 38}}>
                <Home_Tradicion/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12, mb: 12}}>
                <Home_Contactos/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Home    